import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';

import pageConfig from '../../config/page.config';
import { AertechBuilding } from '../../assets/images/images';
import { MHero } from '../../components/molecules/';
import { OUserlist, OCertification } from '../../components/organisme';
import { changeHead } from '../../redux/head/headActions';

import { ABOUT_US_CONFIG } from './about-us.config';

function AboutUsPage({ changeHeadFunc, intl }) {
	useEffect(() => {
		changeHeadFunc({
			title: intl.formatMessage({ id: pageConfig.aboutUs.title }),
			description: intl.formatMessage({ id: pageConfig.aboutUs.description }),
			showSocialMedia: true,
		});
	});

	return (
		<section>
			<MHero
				img={AertechBuilding}
				currentPage="BREAD_CRUMB.ABOUT_US"
			/>
			<article className="section-xx layout-body--xl layout-about-us">
				<p>
					<FormattedMessage id="ABOUT_US.ABOUT_US" defaultMessage="" />
				</p>
			</article>
			<OUserlist
				className="section-xx layout-body--xl a-section--slide-off"
				items={ABOUT_US_CONFIG.user}
			/>
			<article className="section-xx layout-body section--certification">
				<OCertification
					items={ABOUT_US_CONFIG.certification}
				/>
			</article>
		</section>
	);
}

AboutUsPage.propTypes = {
	changeHeadFunc: PropTypes.func.isRequired,
};

export default withRouter(connect(null, {
	changeHeadFunc: changeHead,
})(injectIntl(AboutUsPage)));



// WEBPACK FOOTER //
// ./src/pages/about-us/about-us.page.js